import service, { type HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

interface CompanyMarket {
	national: { [key: string]: boolean };
	locations: Array<{
		coordinates: number[];
		radius: number;
	}>;
	state: string[];
}

interface Company {
	hiddenBusinessIds: string[];
	name: string;
	createdAt: string;
	updatedAt: string;
	companyHsId: string;
	markets: CompanyMarket;
	id: string;
}

interface GetCompaniesResponse {
	companies: Company[];
}

interface MarketCoordinate {
	lat: string;
	lng: string;
	locationName: string;
	streetAddress: string;
	cityName: string;
	stateName: string;
	zipcode: string;
	radius: string;
	marketType: string;
}

interface UpdateCompanyAdminPayload {
	name: string;
	companyHsId?: string;
	marketCoordinates: MarketCoordinate[];
}

interface UpdateCompanyAdminResponseData {
	message: string;
	company: Company;
}

interface CreateAdminPayload {
	name: string;
	companyHsId?: string;
	marketCoordinates: MarketCoordinate[];
}

interface CreateAdminResponseData {
	message: string;
	company: Company;
}

export const getCompanies = (): Promise<
	HttpResponseSuccess<GetCompaniesResponse>
> => {
	return apiService.post('/api/company/getCompanies');
};

export const createCompany = (
	payload: CreateAdminPayload
): Promise<HttpResponseSuccess<CreateAdminResponseData>> => {
	return apiService.post('/api/company/createAdmin', payload);
};

export const updateCompany = (
	payload: UpdateCompanyAdminPayload
): Promise<HttpResponseSuccess<UpdateCompanyAdminResponseData>> => {
	return apiService.post('/api/company/updateCompanyAdmin', payload);
};

export const searchHubspotCompany = (
	params: any
): Promise<HttpResponseSuccess<any>> => {
	return apiService.get('/api/company/searchHubspotCompany', { params });
};

export const updateCompanyHsId = (
	payload: any
): Promise<HttpResponseSuccess<any>> => {
	return apiService.post('/api/company/updateCompanyHubspotId', payload);
};

export const getCompanyHubspotId = (
	params: any
): Promise<HttpResponseSuccess<any>> => {
	return apiService.get('/api/company/getCompanyHubspotId', { params });
};
